/* NutriFitt category covers: gentle fade-up when the covers enter the viewport. */
(() => {
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  const init = (root = document) => {
    root.querySelectorAll('[data-nf-paths]').forEach(section => {
      if (section.dataset.ready) return;
      section.dataset.ready = 'true';
      const designMode = Boolean(window.Shopify && window.Shopify.designMode);
      if (section.dataset.effects !== 'true' || reduced.matches || designMode || !('IntersectionObserver' in window)) return;
      if (section.getBoundingClientRect().top < window.innerHeight * 0.9) return;
      section.classList.add('is-armed');
      const observer = new IntersectionObserver(entries => {
        if (!entries.some(entry => entry.isIntersecting)) return;
        section.classList.add('is-revealed');
        observer.disconnect();
      }, { rootMargin: '0px 0px -12% 0px' });
      observer.observe(section);
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init());
  else init();
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
